import type { MovementInfo } from '@az3fr/core';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { api } from '@/api/api-client';
import { movementSliceActions } from '@/entities/movement/model/movement.slice';
import { useAppDispatch } from '@/hooks/store.hook';

// @TODO: get this from the @az3fr/functions package
interface MovementsResponse {
	data: MovementInfo[];
}

function useLoadAllMovementsRawQuery() {
	const dispatch = useAppDispatch();

	// @todo: fix the typing
	const queryResult = useQuery<MovementsResponse, Error>({
		queryKey: ['movements', 'all', 'raw'],
		queryFn: () => api.get<MovementsResponse>('movements/raw'),
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: Number.POSITIVE_INFINITY,
	});

	// Automatically cache fetched movements in the normalized store
	useEffect(() => {
		if (queryResult.data?.data) {
			dispatch(movementSliceActions.addedMany(queryResult.data.data));
		}
	}, [queryResult.data, dispatch]);

	return queryResult;
}

export { useLoadAllMovementsRawQuery };
